import {
  all,
  call,
  getContext,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import { normalizeDonationArray } from "@helpers/subscriptions";
import { setAuthors } from "../authors/actions";
import {
  addPayoutMethodFailure,
  addPayoutMethodSuccess,
  getAgencyFailure,
  getAgencySuccess,
  getAgencyUsersFailure,
  getAgencyUsersSuccess,
  getListContentRequestsFailure,
  getListContentRequestsSuccess,
  getListDonationsFailure,
  getListDonationsSuccess,
  getListSubscriptionsFailure,
  getListSubscriptionsSuccess,
  getPaymentSubscriptionsFailure,
  getPaymentSubscriptionsSuccess,
  getPortionPaymentSubscriptionsFailure,
  getPortionPaymentSubscriptionsSuccess,
  getPromotionsFailure,
  getPromotionsSuccess,
  setDefaultCardFailure,
  setDefaultCardSuccess,
  submitTransferFailure,
  submitTransferSuccess,
} from "./actions";
import {
  addPayoutMethodActionTypes,
  cryptoTxActionTypes,
  getAgencyActionTypes,
  getAgencyUsersActionTypes,
  getListContentRequestsActionTypes,
  getListDonationsActionTypes,
  getListSubscriptionsActionTypes,
  getPaymentSubscriptionsActionTypes,
  getPaymentSubscriptionsPortionActionTypes,
  getPromotionsActionTypes,
  setDefaultCardActionTypes,
  submitTransferActionTypes,
} from "./actionTypes";
import {
  setPaymentSubscriptionsSuccess,
  setPortionPaymentSubscriptionsSuccess,
} from "../subscriptions/actions";
import {
  normalizePaymentsArray,
  normalizePromotionPayments,
} from "@helpers/payments";
import { setPosts } from "../posts/actions";
import { getWeb3Provider } from "@helpers/metamask";
import { removeEmptyKeys } from "@helpers/common";
import { cryptoTxTypes } from "@const/payments";
import { Web3TxHash, Web3TxHashError } from "../web3/events";
import { getProfile } from "../profile/actions";
import { setDefaultCardAsync } from "@redux/paymentCards/saga";
import { getCards } from "@redux/paymentCards/actions";

const getPaymentSubscriptionsAsync = ({ SubscriptionsService, params }) => {
  if (!SubscriptionsService) {
    console.log("Required services does not exist");

    return;
  }

  return SubscriptionsService.getListPaymentSubscriptions(params);
};

function* getPaymentSubscriptions({ payload }) {
  try {
    const { SubscriptionsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getPaymentSubscriptionsAsync, {
      SubscriptionsService,
      params: payload,
    });

    const { entities, result: allPayments } = normalizePaymentsArray(data);

    const {
      authors,
      subscriptions: subscriptionById,
      payments: paymentsById,
    } = entities;

    const { totalCount, nextOffset } = pagination;

    yield all([
      put(
        setPaymentSubscriptionsSuccess({
          subscriptionById,
        }),
      ),
      put(
        getPaymentSubscriptionsSuccess({
          allPayments,
          paymentsById,
          totalCount,
          nextOffset,
        }),
      ),
      put(setAuthors(authors)),
    ]);
  } catch ({ error }) {
    yield put(getPaymentSubscriptionsFailure(error));
  }
}

function* getPaymentSubscriptionsPortion({ payload }) {
  try {
    const { SubscriptionsService } = yield getContext(CONTEXT.SERVICES);
    const { ...params } = payload;

    const { data, pagination } = yield call(getPaymentSubscriptionsAsync, {
      SubscriptionsService,
      params,
    });

    const { entities, result: allPayments } = normalizePaymentsArray(data);

    const {
      authors,
      subscriptions: subscriptionById,
      payments: paymentsById,
    } = entities;

    const { totalCount, nextOffset } = pagination;

    yield all([
      put(
        setPortionPaymentSubscriptionsSuccess({
          subscriptionById,
        }),
      ),
      put(
        getPortionPaymentSubscriptionsSuccess({
          allPayments,
          paymentsById,
          totalCount,
          nextOffset,
        }),
      ),

      put(setAuthors(authors)),
    ]);
  } catch ({ error }) {
    yield put(getPortionPaymentSubscriptionsFailure(error));
  }
}

const submitTransferAsync = ({ PaymentsService, id, hash }) => {
  if (!PaymentsService) {
    console.log("Required service is missing");
    return;
  }

  return PaymentsService.updateCryproTxHash(id, { transactionHash: hash });
};

function* submitTransfer({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { hash, id } = payload;
    yield call(submitTransferAsync, {
      id,
      hash,
      PaymentsService,
    });
    yield put(submitTransferSuccess(hash));
  } catch ({ error }) {
    yield put(submitTransferFailure(error));
  }
}

const getListSubscriptionsAsync = ({ PaymentsService, params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");

    return;
  }

  return PaymentsService.getListSubscriptions(params);
};

const getListContentRequestsAsync = ({ PaymentsService, params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");

    return;
  }

  return PaymentsService.getListContentRequests(params);
};

function* getListSubscriptions({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getListSubscriptionsAsync, {
      PaymentsService,
      params: payload,
    });

    const { entities, result: allPayments } = normalizePaymentsArray(data);

    const {
      authors,
      subscriptions: subscriptionById,
      payments: paymentsById,
    } = entities;

    const { totalCount, nextOffset } = pagination;

    yield all([
      put(
        setPaymentSubscriptionsSuccess({
          subscriptionById,
        }),
      ),
      put(
        getListSubscriptionsSuccess({
          allPayments,
          paymentsById,
          totalCount,
          nextOffset,
        }),
      ),

      put(setAuthors(authors)),
    ]);
  } catch ({ error }) {
    yield put(getListSubscriptionsFailure(error));
  }
}

function* getListContentRequests({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getListContentRequestsAsync, {
      PaymentsService,
      params: payload,
    });

    const { entities, result: allPayments } = normalizePaymentsArray(data);
    const { payments: paymentsById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield all([
      put(
        getListContentRequestsSuccess({
          allPayments,
          totalCount,
          nextOffset,
          paymentsById,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getListContentRequestsFailure(error));
  }
}

const getListDonationsAsync = ({ PaymentsService, params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");

    return;
  }

  return PaymentsService.getListDonations(params);
};

function* getListDonations({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getListDonationsAsync, {
      PaymentsService,
      params: payload,
    });

    const { entities, result: allPayments } = normalizeDonationArray(data);

    const { authors, post: postById, payments: paymentsById } = entities;
    const { totalCount, nextOffset } = pagination;

    yield all([
      put(
        setPosts({
          postById,
        }),
      ),
      put(
        getListDonationsSuccess({
          allPayments,
          paymentsById,
          totalCount,
          nextOffset,
        }),
      ),
      put(setAuthors(authors)),
    ]);
  } catch ({ error }) {
    yield put(getListDonationsFailure(error));
  }
}

const createTxInstanceAsync = ({ PaymentsService, ...body }) => {
  return PaymentsService.createCryptoTxInstance(removeEmptyKeys(body));
};

async function* createCryptoTx({ payload }) {
  const { PaymentsService, ToasterService } = yield getContext(
    CONTEXT.SERVICES,
  );

  try {
    let model;
    const provider = yield call(getWeb3Provider);

    if (!provider) {
      throw new Error("WARNING_CONNECT_META");
    }

    const {
      metamaskWallet,
      recipientId,
      postId,
      type,
      amount,
      subscriptionId,
      userSubscriptionId,
      durationType,
    } = payload;

    if (type === cryptoTxTypes.donation) {
      model = {
        type,
        recipientId,
        postId,
        amount,
      };
    }

    if (type === cryptoTxTypes.post) {
      model = {
        amount,
        postId,
        type,
      };
    }

    if (type === cryptoTxTypes.subscription) {
      model = {
        subscriptionId,
        userSubscriptionId,
        durationType,
        type,
      };
    }

    const {
      data: { id, amount: txAmount },
    } = yield call(createTxInstanceAsync, {
      PaymentsService,
      ...model,
    });

    const Web3 = yield call(() => import("web3"));
    const web3 = new Web3(provider);
    const inWei = web3.utils.toWei(`${txAmount}`);
    const currentAddress = web3.eth.personal.currentProvider?.selectedAddress;
    const chainId = yield call(web3.eth.getChainId);

    if (!currentAddress) {
      throw new Error("WARNING_CONNECT_META");
    }

    web3.eth
      .sendTransaction(
        {
          chainId,
          from: currentAddress,
          to: metamaskWallet,
          value: inWei,
        },
        (error) => {
          if (error) {
            window.dispatchEvent(
              new CustomEvent(Web3TxHashError, {
                detail: { error },
              }),
            );
          }
        },
      )
      .once("transactionHash", (hash) =>
        window.dispatchEvent(
          new CustomEvent(Web3TxHash, {
            detail: {
              id,
              hash,
            },
          }),
        ),
      );
  } catch (e) {
    ToasterService.errorTranslated(
      e?.message || e.error?.message || "Something went wrong",
    );
    yield put(submitTransferFailure());
  }
}

const getPromotionsAsync = ({ PaymentsService, ...params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");
    return;
  }

  return PaymentsService.getPromotions(params);
};

const getAgencyAsync = ({ PaymentsService, ...params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");
    return;
  }

  return PaymentsService.getAgency(params);
};

const addPayoutMethodAsync = ({ PaymentsService, ...params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");
    return;
  }

  return PaymentsService.addPayoutMethod(params);
};

const getAgencyUsersAsync = ({ PaymentsService, ...params }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");
    return;
  }

  return PaymentsService.getAgencyUsers(params);
};

function* getPromotions({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { pagination, data } = yield call(getPromotionsAsync, {
      PaymentsService,
      ...payload,
    });
    const { totalCount, nextOffset } = pagination;
    const { entities, result: allPayments } = normalizePromotionPayments(data);

    const { authors, payments, paymentTransaction } = entities;

    yield all([
      put(setAuthors(authors)),
      put(
        getPromotionsSuccess({
          allPayments,
          paymentsById: payments,
          promotionTransactionsById: paymentTransaction,
          totalCount,
          nextOffset,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getPromotionsFailure(error));
  }
}

function* getAgency({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const { pagination, data } = yield call(getAgencyAsync, {
      PaymentsService,
      ...payload,
    });
    const { totalCount, nextOffset } = pagination;
    const { entities, result: allPayments } = normalizePromotionPayments(data);

    const { payments, paymentTransaction } = entities;

    yield all([
      put(
        getAgencySuccess({
          allPayments,
          paymentsById: payments,
          promotionTransactionsById: paymentTransaction,
          totalCount,
          nextOffset,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getAgencyFailure(error));
  }
}

function* addPayoutMethod({ payload }) {
  const { PaymentsService, ToasterService } = yield getContext(
    CONTEXT.SERVICES,
  );

  try {
    yield call(addPayoutMethodAsync, {
      PaymentsService,
      ...payload,
    });
    yield put(getProfile());
    yield put(addPayoutMethodSuccess());
  } catch ({ error }) {
    if (error?.message) {
      ToasterService.error(error.message);
    }
    yield put(addPayoutMethodFailure(error));
  }
}

function* setDefaultCard({ payload }) {
  const { id } = payload;
  try {
    const { CardsService } = yield getContext(CONTEXT.SERVICES);
    yield call(setDefaultCardAsync, {
      CardsService,
      id,
    });
    yield put(getCards());
    yield put(setDefaultCardSuccess());
  } catch ({ error }) {
    yield put(setDefaultCardFailure(error));
  }
}

function* getAgencyUsers({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    const users = yield call(getAgencyUsersAsync, {
      PaymentsService,
      payload,
    });
    yield put(getAgencyUsersSuccess(users.data));
  } catch ({ error }) {
    yield put(getAgencyUsersFailure(error));
  }
}

export function* watchGetPaymentSubscription() {
  yield takeEvery(
    getPaymentSubscriptionsActionTypes.request,
    getPaymentSubscriptions,
  );
}

export function* watchGetPaymentSubscriptionPortion() {
  yield takeEvery(
    getPaymentSubscriptionsPortionActionTypes.request,
    getPaymentSubscriptionsPortion,
  );
}

export function* watchSubmitTransfer() {
  yield takeEvery(submitTransferActionTypes.request, submitTransfer);
}

export function* watchGetListSubscription() {
  yield takeLatest(
    getListSubscriptionsActionTypes.request,
    getListSubscriptions,
  );
}

export function* watchGetListContentRequests() {
  yield takeLatest(
    getListContentRequestsActionTypes.request,
    getListContentRequests,
  );
}

export function* watchGetListDonations() {
  yield takeEvery(getListDonationsActionTypes.request, getListDonations);
}

export function* watchCryptoTx() {
  yield takeEvery(cryptoTxActionTypes.request, createCryptoTx);
}

export function* watchGetPromotions() {
  yield takeLatest(getPromotionsActionTypes.request, getPromotions);
}

export function* watchGetAgency() {
  yield takeLatest(getAgencyActionTypes.request, getAgency);
}

export function* watchAddPayoutMethod() {
  yield takeLatest(addPayoutMethodActionTypes.request, addPayoutMethod);
}

export function* watchSetDefaultCard() {
  yield takeLatest(setDefaultCardActionTypes.request, setDefaultCard);
}

export function* watchGetAgencyUsers() {
  yield takeLatest(getAgencyUsersActionTypes.request, getAgencyUsers);
}
